import { Tooltip } from "@material-ui/core";
import { memo } from "react";

import { useStyles } from "@/common/components/MapLandingPage/Map/ClusterMarker/ClusterMarkerStyles";


interface Props {
    handleClick: (clusterId: number) => void;
    id: number;
    lat: number;
    lng: number;
    text: string;
}

const ClusterMarker: React.FC<Props> = ({ id, text, handleClick }) => {
    const classes = useStyles();

    return (
        <Tooltip title="LiveUnit Cluster (click to zoom)" classes={{ popper: classes.tooltip }}>
            <div className={classes.marker} onClick={() => handleClick(id)}>
                {text}
            </div>
        </Tooltip>
    );
};

export default memo(ClusterMarker);
